/**
 * Shared Tailwind class recipes — prefer these over copy-pasting class strings.
 * Prefer <AppButton> for actions (colored + icon). These strings match AppButton variants.
 */

export const ds = {
  card: 'rounded-ds-2xl border border-line bg-surface shadow-ds-card overflow-hidden',
  pageBg: 'bg-surface-page',
  label: 'text-[11px] font-bold text-ink uppercase tracking-widest',
  input:
    'mt-1 w-full rounded-ds-xl border border-line bg-surface px-3 py-2 text-sm font-medium text-ink outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-500/20',
  select:
    'mt-1 w-full rounded-ds-xl border border-line bg-surface px-3 py-2 text-sm font-medium text-ink outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-500/20',
  /** Brand violet — Apply / main CTA */
  btnPrimary:
    'inline-flex items-center justify-center gap-1.5 rounded-ds-xl bg-brand-600 px-4 py-2 text-xs font-semibold text-white hover:bg-brand-700 disabled:opacity-50 transition-colors',
  /** Green — Approve / Accept / Mark Paid */
  btnSuccess:
    'inline-flex items-center justify-center gap-1.5 rounded-ds-xl bg-emerald-600 px-4 py-2 text-xs font-semibold text-white hover:bg-emerald-700 disabled:opacity-50 transition-colors',
  /** Red — Reject / Delete */
  btnDanger:
    'inline-flex items-center justify-center gap-1.5 rounded-ds-xl bg-red-600 px-4 py-2 text-xs font-semibold text-white hover:bg-red-700 disabled:opacity-50 transition-colors',
  /** Sky blue — Refresh / Recalculate (same everywhere) */
  btnRefresh:
    'inline-flex items-center justify-center gap-1.5 rounded-ds-xl bg-sky-600 px-4 py-2 text-xs font-semibold text-white hover:bg-sky-700 disabled:opacity-50 transition-colors',
  /** Slate — Update / Open / neutral actions */
  btnSecondary:
    'inline-flex items-center justify-center gap-1.5 rounded-ds-xl bg-slate-600 px-4 py-2 text-xs font-semibold text-white hover:bg-slate-700 disabled:opacity-50 transition-colors',
  /** Amber — Unlock / caution */
  btnWarning:
    'inline-flex items-center justify-center gap-1.5 rounded-ds-xl bg-amber-600 px-4 py-2 text-xs font-semibold text-white hover:bg-amber-700 disabled:opacity-50 transition-colors',
  /** Teal — Copy / info */
  btnInfo:
    'inline-flex items-center justify-center gap-1.5 rounded-ds-xl bg-teal-600 px-4 py-2 text-xs font-semibold text-white hover:bg-teal-700 disabled:opacity-50 transition-colors',
  btnGhost:
    'inline-flex items-center justify-center gap-1.5 rounded-ds-xl bg-brand-600 px-2.5 py-1 text-xs font-semibold text-white hover:bg-brand-700 disabled:opacity-50 transition-colors',
  tabActive: 'rounded-ds-xl bg-brand-600 px-3 py-2 text-xs font-bold text-white border border-brand-600',
  tabIdle: 'rounded-ds-xl bg-slate-100 px-3 py-2 text-xs font-bold text-slate-700 border border-slate-200',
  tableShell: 'w-full text-sm text-ink',
  th: 'px-4 py-3 text-left whitespace-nowrap',
  td: 'px-4 py-3 text-ink',
  /** Apply on every data <tr> for zebra + full-row hover (incl. sticky first col) */
  row: 'list-stripe-row',
};

export const statusBadgeTone = {
  success: 'bg-success-50 text-success-800 border-success-100',
  warning: 'bg-warning-50 text-warning-800 border-warning-100',
  danger: 'bg-danger-50 text-danger-800 border-danger-100',
  info: 'bg-info-50 text-info-800 border-info-100',
  neutral: 'bg-surface-muted text-ink-muted border-line',
  brand: 'bg-brand-50 text-brand-700 border-brand-200',
};
